// extracted by mini-css-extract-plugin
module.exports = {"slate-alignment-plugin--button-bar":"AlignmentButtonBar_slate-alignment-plugin--button-bar__oiQ6K"};